import { render, staticRenderFns } from "./IbChartsPlaceholderType.vue?vue&type=template&id=425e1912&scoped=true"
import script from "./IbChartsPlaceholderType.vue?vue&type=script&lang=js"
export * from "./IbChartsPlaceholderType.vue?vue&type=script&lang=js"
import style0 from "./IbChartsPlaceholderType.vue?vue&type=style&index=0&id=425e1912&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425e1912",
  null
  
)

export default component.exports